












































/* General */
import Vue from 'vue'
import CardCanvas from '@/layouts/card-canvas.vue'

/* Mixins */

/* Components */
import GuestRoster from './components/guest-roster.vue'

/* Helpers */

import RouteAssistant from '@/helpers/route-assistant'

/* Data types */
import { ICompanyRoster } from '@/api/types/response.types'

/* API */
import CompaniesAPI from '@/api/modules/companies.api'

export default Vue.extend({
  name: 'CompanyGuestsCreate',

  metaInfo(): any {
    return {
      title: this.company.name,
    }
  },

  components: {
    CardCanvas,
    GuestRoster,
  },

  data() {
    return {
      isLoading: true,
      isSubmitting: false,
      focusName: false,
      companyName: '',
      RouteAssistant,
      company: {} as ICompanyRoster,
    }
  },

  computed: {
    companyID(): number {
      return Number(this.$route.params.companyId)
    },
    accountID(): number {
      return parseInt(this.$route.params.accountId, 10)
    },
    noPeopleInCompany(): boolean {
      return this.company.numberOfPeople === 0
    },
  },

  async created() {
    this.isLoading = true
    await this.fetchCompanyRoster()
    this.isLoading = false
  },

  methods: {
    focusNameField(): void {
      this.focusName = false
      this.$nextTick(() => {
        this.focusName = true
      })
    },
    async fetchCompanyRoster() {
      try {
        this.company = await CompaniesAPI.get_GuestsRoster(this.companyID)
        this.companyName = this.company.name
      } catch (error) {
        this.$error.emit(error)
        RouteAssistant.goToGuests(this.$router, this.accountID)
      }
    },
    async updateName() {
      try {
        if (
          this.companyName.trim().length === 0 ||
          this.companyName.trim() === this.company.name.trim()
        ) {
          this.companyName = this.company.name
          return
        }

        if (this.isSubmitting) {
          return
        }

        this.isSubmitting = true

        const response = await CompaniesAPI.put_UpdateName(
          this.companyID,
          this.companyName,
        )
        this.$messaging.showSuccess(response.message)
        this.company.name = this.companyName
      } catch (error) {
        this.$error.emit(error, true)
      } finally {
        this.isSubmitting = false
      }
    },
    async deleteCompany() {
      try {
        const response = await CompaniesAPI.delete_Delete(this.companyID)
        this.$messaging.showSuccess(response.message)
        RouteAssistant.goToPeople(this.$router, this.accountID)
      } catch (error) {
        this.$error.emit(error, true)
      }
    },
  },
})
